import React from "react";
import Stepper from "react-stepper-horizontal";

function HorizontalStepper({ steps, activeStep }) {
  return (
    <Stepper
      activeStep={activeStep}
      steps={steps}
      completeColor="#999f97"
      activeColor="#3E4E3A"
      defaultColor="#b9b9b9"
    />
  );
}

export default HorizontalStepper;
